import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Row, Col, Button } from 'reactstrap';
import DateTimePicker from '../../common/controls/dateTimePicker';
import Icon from '../../common/containers/icon';
import SinglePicker from '../../common/controls/singlePicker';
import MultiPicker from '../../common/controls/multiPicker';
import CertificationDocumentLinks from './certificationDocumentLinks';
import entityComposition from '../../common/classes/entityComposition';
class CertificationForm extends React.Component {
  constructor(props) {
    super(props);
    const {
      onChange,
      index,
      onRemove,
      userCertificationType,
      userCertificationTypeActions,
      documentCertificationForm,
      documentCertificationFormActions
    } = props;
    userCertificationTypeActions.serverIndex(userCertificationType.indexQuery);
    documentCertificationFormActions.serverIndex(documentCertificationForm.indexQuery);
    this.handleChange = (name, value) => onChange(index, name, value);
    this.handleChangeDocuments = value => this.handleChange('documents', _.pluck(value, 'id'));
    this.handleRemove = () => onRemove(index);
    this.handleChangeUserCertificationType = value => this.handleChange('userCertificationTypeID', value);
    this.handleChangeStartDate = value => this.handleChange('startDate', value);
    this.handleChangeEndDate = value => this.handleChange('endDate', value);
  }
  render() {
    const {
      userCertificationType,
      certification,
      documentCertificationForm
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Certification",
      labelKey: "name",
      onChange: this.handleChangeUserCertificationType,
      options: userCertificationType.list,
      placeholder: "Select...",
      returnValueKey: "id",
      value: certification.userCertificationTypeID
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      style: {
        position: 'relative',
        top: '2em'
      },
      className: "form-control t-cs-remove-certification tqc-control",
      onClick: this.handleRemove
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Certification"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      className: "t-cf-start-date",
      onChange: this.handleChangeStartDate,
      label: "Date Issued",
      defaultValue: certification.startDate
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      className: "t-cf-end-date",
      onChange: this.handleChangeEndDate,
      label: "Expiration / Renewal Date",
      defaultValue: certification.endDate
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(MultiPicker, {
      className: "t-cf-associated-documents",
      label: "Associated Documents",
      labelKey: "displayName",
      onChange: this.handleChangeDocuments,
      options: documentCertificationForm.list,
      placeholder: "Select...",
      returnValueKey: "id",
      values: certification.documents
    }), /*#__PURE__*/React.createElement(CertificationDocumentLinks, {
      documents: certification.documents,
      options: documentCertificationForm.list
    }))), /*#__PURE__*/React.createElement("hr", null));
  }
}
CertificationForm.propTypes = {
  userCertificationType: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  userCertificationTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  documentCertificationForm: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  documentCertificationFormActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  certification: PropTypes.shape({
    userCertificationTypeID: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    documents: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]))
  }).isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
export { CertificationForm as TestCertificationForm };
export default entityComposition(CertificationForm, ['userCertificationType', 'documentCertificationForm']);